import FormatHelper from "@/helpers/format.helper.js";

class AlarmFormatter {

    // ---------- Single alarm ----------
    alarmFormat(alarm) {
        if (!alarm) return null;

        const alarmTypeMetaSource =
            alarm.alarmTypeMeta ||
            alarm.AlarmType ||
            (alarm.alarmType && typeof alarm.alarmType === "object" ? alarm.alarmType : null) ||
            null;

        return {
            id: alarm.id,
            latitude: alarm.latitude,
            longitude: alarm.longitude,
            battery: alarm.battery,
            address: alarm.address,
            speed: alarm.speed,
            direction: alarm.direction,
            powerVoltage: alarm.powerVoltage,

            date: FormatHelper.formatDate(alarm.date),
            createdAt: FormatHelper.formatDate(alarm.createdAt),
            updatedAt: FormatHelper.formatDate(alarm.updatedAt),

            alertName: alarmTypeMetaSource?.name ?? null,
            alarmType: alarm.alarmTypeId ?? alarm.alarmType ?? null,
            alarmTypeId: alarm.alarmTypeId ?? alarm.alarmType ?? null,
            data: alarm.data,
            alarmTypeMeta: alarmTypeMetaSource
                ? {
                    id: alarmTypeMetaSource.id ?? null,
                    name: alarmTypeMetaSource.name ?? null,
                    severity: alarmTypeMetaSource.severity ?? null,
                }
                : null,

            balise: alarm.balise
                ? FormatHelper.baliseInfoFormat(alarm.balise)
                : null
        };
    }

    // ---------- Array of alarms ----------
    alarmsFormat(data) {
        if (!Array.isArray(data)) return [];
        return data.map(a => this.alarmFormat(a));
    }

    // ---------- Sequelize findAndCountAll ----------
    alarmsSearchFormat(data) {
        const rows = data && Array.isArray(data.rows) ? data.rows : [];
        const count =
            data && data.count !== undefined && data.count !== null
                ? data.count
                : rows.length;

        return {
            rows: this.alarmsFormat(rows),
            count
        };
    }

    // ---------- Alarm Types ----------
    alarmTypesFormat(data) {
        if (!Array.isArray(data)) return [];

        return data.map(t => ({
            ...t,
            id: t.id,
            name: t.name ?? null,
            severity: t.severity ?? null,
            display: t.display ?? 1
        }));
    }

}

export default new AlarmFormatter();
